module.exports = __webpack_public_path__ + "static/ebook_mobile-625f845204f33430f8f9fb6d48d12d75.jpg";